import React from 'react';
import { Handle, Position } from 'reactflow';
import { Send } from 'lucide-react';

const SendMessageNode = ({ data }) => {
  return (
    <div className="bg-blue-100 border-2 border-blue-400 rounded-lg p-4 min-w-[200px]">
      <Handle 
        type="target" 
        position={Position.Top} 
        className="!w-4 !h-4 !bg-blue-500 !border-2 !border-white"
        style={{ top: -8 }}
      />
      <div className="flex items-center gap-2 mb-2">
        <Send size={20} className="text-blue-600" />
        <div className="font-semibold text-blue-900">Send Message</div>
      </div>
      <div className="text-sm text-blue-700 truncate">
        {data.message || 'No message set'}
      </div>
      <Handle 
        type="source" 
        position={Position.Bottom} 
        className="!w-4 !h-4 !bg-blue-500 !border-2 !border-white"
        style={{ bottom: -8 }}
      />
    </div>
  );
};

export default SendMessageNode;
